import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
// import { useQueryClient } from '@tanstack/react-query';
import { useGetOrganizationChangeView } from 'hooks/useOrganizationNewHooks';
// import { useGetProfileById } from 'hooks/useProfileHooks';
import React from 'react';
import { useNavigate } from 'react-router';
import { toastConfig } from 'utils/commonUtil';

const ViewOrganizationChange = ({
  openModal,
  setOpenModal,
  // handleSubmit,
  title,
  subTitle,

  // details,
  orgViewchangeId
}) => {
  const navigate = useNavigate();
  const handleClose = () => {
    setOpenModal(false);
  };
  const { mutate: viewChangeOrg, isPending: isViewChangeOrgLoading } = useGetOrganizationChangeView();
  const queryClient = useQueryClient();
  const handleSubmit = () => {
    viewChangeOrg(
      {
        id: orgViewchangeId
      },
      {
        onSuccess: (res) => {
          // console.log('🚀 ~ handleSubmit ~ resLogged in:', res);
          if (res?.status === 200) {
            toastConfig.type = 'success';
            // setToast(toastConfig, res?.data?.message);

            // Overwrite with new data
            localStorage.setItem('userJwtToken', res?.data?.data?.token);
            // localStorage.setItem(
            //   'userJwtToken',
            //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3N2U2OGJkOTY3YzE1ZjdhYzE1MzA3YiIsInR5cGVzIjpbIk1haW4gUE9DIiwiU2Vjb25kYXJ5IFBPQyJdLCJvcmdhbml6YXRpb25UeXBlcyI6WyJTdXBlckFkbWluIiwiRW50ZXJwcmlzZSIsIlJlY3ljbGVyIiwiUmV0YWlsZXIiLCJSZXNlbGxlciIsIlNlcnZpY2VQcm92aWRlciJdLCJpYXQiOjE3NDQ2MTkyMDMsImV4cCI6MTc3NjE3NjgwM30.uF8HmRmtIYttXii6PURhF6oxjffaKcAS2uKRlJVF0CQ'
            // );
            localStorage.setItem('userData', JSON.stringify(res?.data?.data?.user));
            localStorage.setItem('userOrgId', JSON.stringify(res?.data?.data?.user?.id));
            localStorage.setItem('viewChangeOrgName', JSON.stringify(res?.data?.data?.user?.orgName));
            localStorage.setItem('isViewChange', 1);

            const organizationTypes = res?.data?.data?.user?.organizationTypes;
            const userTypes = res?.data?.data?.user?.types;

            localStorage.setItem(
              'orgType',
              organizationTypes && Array.isArray(organizationTypes) && organizationTypes.length > 0 ? organizationTypes[0] : null
            );
            localStorage.setItem('userType', userTypes && Array.isArray(userTypes) && userTypes.length > 0 ? userTypes[0] : null);

            setOpenModal(false); // Close dialog on success

            navigate('/dashboard/default');
            // setTimeout(() => {

            // }, 100);
            queryClient.invalidateQueries(['getProfileDataById']);
          } else {
            toastConfig.type = 'error';
            // setToast(toastConfig, res?.data?.message);
            setOpenModal(false);
          }
        },
        onError: () => {
          toastConfig.type = 'error';
          // setToast(toastConfig, error?.response?.data?.error);
          setOpenModal(false);
        }
      }
    );
  };
  return (
    <>
      <Dialog
        open={openModal}
        fullScreen={false}
        fullWidth={false}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        className="dlte_file_mdlnw machine-settings"
        //   className="dlte_file_mdlnw machine-settings"
      >
        <DialogTitle
          id="alert-dialog-title"
          variant="span"
          style={{
            textTransform: 'capitalize'
          }}
        >
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{subTitle}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button
              fullWidth
              variant="contained"
              type="submit"
              onClick={handleSubmit}
              style={{
                color: '#fff'
              }}
              color="primary"
              disabled={isViewChangeOrgLoading}
            >
              Yes
              {isViewChangeOrgLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: '#16B1FF',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px'
                  }}
                />
              )}
            </Button>
          </Box>
          <Button variant="outlined" type="reset" color="error" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewOrganizationChange;
